<template>
  <div class="yxtbiz-rank__one-column pr">
    <!-- 榜单名称 -->
    <rank-title
      v-if="!styleObject.hideHeader"
      ref="rankTitle"
      @changeDate="$emit('changeDate', $event)"
      class="mb16"
      ><div slot="title"><slot name="title"></slot></div
    ></rank-title>
    <!-- 排名列表的标题 -->
    <div v-if="isFixed" class="yxtbiz-rank__one-column-rank-box-fixed">
    <div 
      class="flex standard-size-14 text-8c yxtbiz-rank__one-column-rank-box mb16 ml8 mr8"
    >
      <div class="flex">
        <div class="mr12 yxtbiz-rank__one-column-rank">
          {{ $t('pc_biz_rank_rank').d('排名') }}
        </div>
        <div v-if="contentObj.primaryCode">
          {{ contentObj.objectName }}
        </div>
      </div>
      <div v-if="contentObj.attributeCode">
        {{ contentObj.attributeName }}
      </div>
    </div>
    </div>
    <div
      :style="{ height: height ? height - 88 + 'px' : 'auto' }"
      :class="{
        'yxtbiz-rank__one-column-no-data':
          height && (!rankData.rankList || !rankData.rankList.length)
      }"
    >
      <yxtf-scrollbar
        v-if="rankData.rankList && rankData.rankList.length"
        fit-height
        ref="scrollBox"
      >
        <!-- 横排式 前三名 -->
        <horizontal-head
          v-if="styleObject.showStyle === 2"
          class="mt16"
          :rank-data="rankData.rankList.slice(0, sliceNum)"
        />
        <!-- 我的排名 -->
        <my-rank
          v-if="!styleObject.hideMyRank"
          :myRankData="rankData.myRankData"
          :styleType="1"
          class="mb16"
        />
        <!-- 排名列表的标题 -->
        <div
          v-if="rankData.rankList.length > sliceNum"
          ref="listTitle"
          class="flex standard-size-14 text-8c yxtbiz-rank__one-column-rank-box mb16 ml8 mr8"
        >
          <div class="flex">
            <div class="mr12 yxtbiz-rank__one-column-rank">
              {{ $t('pc_biz_rank_rank').d('排名') }}
            </div>
            <div v-if="contentObj.primaryCode">
              {{ contentObj.objectName }}
            </div>
          </div>
          <div v-if="contentObj.attributeCode">
            {{ contentObj.attributeName }}
          </div>
        </div>
        <!-- 排名列表 -->
        <div>
          <div
            v-for="(item, index) of rankData.rankList.slice(sliceNum)"
            :key="index"
          >
            <row-item :rowData="item" />
          </div>
        </div>
      </yxtf-scrollbar>
      <div v-else>
        <yxtf-empty
          v-if="initFlag < 1"
          size="small"
          :empty-text="
            apiError
              ? $t('pc_biz_rank_no_server').d('哎呀~服务器开小差啦~')
              : $t('pc_biz_lbl_nodata').d('暂无数据')
          "
          ><div slot="image" v-if="apiError">
            <yxt-svg
              :remote-url="`${$staticBaseUrl}ufd/3f5568/common/h5/svg/`"
              icon-class="no-server"
            /></div
        ></yxtf-empty>
      </div>
    </div>
  </div>
</template>
<script>
import rowItem from '../component/rowitem.vue';
import horizontalHead from '../component/horizontalHead.vue';
import myRank from '../component/myRank.vue';
import rankTitle from '../component/rankTitle.vue';

export default {
  components: {
    rowItem,
    horizontalHead,
    myRank,
    rankTitle
  },
  props: {
    // 榜单数据
    rankData: {
      type: Object,
      default: () => {}
    },
    // 排行榜高度
    height: {
      type: Number,
      default: 0
    },
    // 获取榜单数据的接口报错
    apiError: {
      type: Boolean,
      default: false
    },
    // 记录是否调用过接口
    initFlag: {
      type: Number,
      default: 2
    }
  },
  inject: ['styleFun', 'contentFun', 'titleFun'],
  computed: {
    // styleType 样式类型: 1 一列式、2 两列式, showStyle 展示样式: 1 列表式、2 横排式
    styleObject() {
      return this.styleFun();
    },
    sliceNum() {
      return this.styleObject.showStyle === 2 ? 3 : 0;
    },
    // 显示内容数据
    contentObj() {
      return this.contentFun();
    },
    // 榜单名称数据
    titleObj() {
      return this.titleFun();
    }
  },
  watch: {
    rankData(val) {
      this.isFixed = false;
      if (this.height && val.rankList && val.rankList.length) {
        this.onScroll();
      }
    }
  },
  data() {
    return {
      isFixed: false // 是否吸顶
    };
  },
  methods: {
    // 页面刷新后，滚动到顶部
    scrollToTop() {
      this.$refs.scrollBox &&
        this.$refs.scrollBox.$refs.wrap &&
        (this.$refs.scrollBox.$refs.wrap.scrollTop = 0);
    },
    // 列表滚动事件
    onScroll() {
      this.$nextTick(() => {
        const dom = this.$refs.scrollBox.$refs.wrap;
        const _this = this;
        dom.onscroll = function() {
          window.requestAnimationFrame(() => {
            if (_this.$refs.rankTitle && _this.$refs.listTitle) {
              const titleTop =
                _this.$refs.rankTitle.$el.getBoundingClientRect().top +
                _this.$refs.rankTitle.$el.getBoundingClientRect().height +
                16;
              const top = _this.$refs.listTitle.getBoundingClientRect().top;
              _this.isFixed = titleTop >= top;
            } else {
              _this.isFixed = false;
            }
          });
        };
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
